import { notification } from "antd";

const messagesOverride = Object.freeze({
  OperationDenied:
    "We're sorry, but the operation you're attempting is not permitted.",
});

const toCamelCase = (inputString = "") =>
  inputString
    ? inputString
        .split(" ")
        .map((word, index) =>
          index === 0
            ? word
            : `${word.charAt(0).toUpperCase()}${word.slice(1)}`,
        )
        .join("")
    : inputString;

export const showNotification = ({
  type,
  message,
  description = null,
  duration = 5,
}) => {
  if (!type || !message) {
    return;
  }

  const camelCaseMessage = toCamelCase(message);
  const notificationArgs = {
    message: messagesOverride[camelCaseMessage] || message,
    duration: duration,
  };

  if (description) {
    notificationArgs.description = description;
  }

  notification[type](notificationArgs);
};

export const hideNotification = () => {
  notification.destroy();
};
